import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { tap } from 'rxjs/operators';
/*import { LoggerService } from '../util-services/logger.service';*/
import { InitAuthService } from '@app/services/global-services/auth/init-auth-service';
import { environment } from '@src/environments/environment';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';

/*
@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(
    private initAuthService: InitAuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.initAuthService.isAuthenticated().pipe(
      tap((isAuthenticated: boolean) => {
        // LoggerService.log('Inside AuthGuard ', isAuthenticated);
        if (!isAuthenticated) {
          if (environment.webApp) {
            this.router.navigateByUrl('/').then();
          } else {
            this.router.navigateByUrl('/welcome').then();
          }
        }
      })
    );
  }
}
*/

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const initAuthService: InitAuthService = inject(InitAuthService);
  const b2bDeviceUtilService: B2bDeviceUtilService =
    inject(B2bDeviceUtilService);

  const router: Router = inject(Router);

  return initAuthService.isAuthenticated().pipe(
    tap((isAuthenticated: boolean) => {
      // LoggerService.log('Inside AuthGuard ', isAuthenticated);
      if (!isAuthenticated) {
        if (environment.webApp) {
          if (b2bDeviceUtilService?.isDesktop()) {
            router.navigateByUrl('/').then();
          } else {
            router.navigateByUrl('/auth/login').then();
          }
        } else {
          router.navigateByUrl('/auth/login').then();
        }
      }
    }),
  );
};
